// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicyPage_container__ZFjy0"};